import React, { useCallback, useEffect, useState } from "react";
import Style from "../assets/css/main.module.css";
import Breadcrumbs from "../components/breadcrumbs/Breadcrumbs";
import api from "../api/api";
import ParkCard from "./ParkCard";
import Laoder from "../components/loader/Loader";

function RenderParks({ parksData }) {
  if (parksData === "loading") return <LoadingParks />;
  if (parksData === "error") return <ErrorParks />;
  if (parksData.length === 0) return <NoParks />;
  if (parksData.length > 0) return <ShowParks parksData={parksData} />;
}

function ErrorParks() {
  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{
        maxWidth: "1440px",
        width: "100%",
        margin: "0 auto",
        minHeight: "75dvh",
      }}
    >
      <div className="text-center">
        <img
          className="mb-4"
          src="https://s3-ap-south-1.amazonaws.com/shohoz-bus/prod/no_trips.svg?v=1.0.1"
          alt="no parks"
        />
        <p>Network Error Occurred</p>
      </div>
    </div>
  );
}

function LoadingParks() {
  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{
        maxWidth: "1440px",
        width: "100%",
        margin: "0 auto",
        minHeight: "75dvh",
      }}
    >
      <div className="text-center">
        <Laoder />
      </div>
    </div>
  );
}

function ShowParks({ parksData }) {
  return (
    <div className={Style.content_container}>
      <div className="container-md py-4">
        {parksData.map((park) => (
          <ParkCard park={park} />
        ))}
      </div>
    </div>
  );
}

function NoParks() {
  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{
        maxWidth: "1440px",
        width: "100%",
        margin: "0 auto",
        minHeight: "75dvh",
      }}
    >
      <div className="text-center">
        <img
          className="mb-4"
          src="https://s3-ap-south-1.amazonaws.com/shohoz-bus/prod/no_trips.svg?v=1.0.1"
          alt="no parks"
        />
        <p>No parks available</p>
      </div>
    </div>
  );
}

export default function SearchResults() {
  const [parksData, setParksData] = useState("loading");

  const extractQueryString = () => {
    const queryString = window.location.search;
    const queryParams = new URLSearchParams(queryString);
    const name = queryParams.get("name");
    const address = queryParams.get("address");
    return { name, address };
  };

  const fetch = useCallback(async () => {
    const { name, address } = extractQueryString();
    if (name || address) {
      const res = await api.parks({
        name: name || "",
        address: address || "",
      });
      if (res?.status === 200) {
        setParksData(res?.data?.data || []);
      } else setParksData("error");
    }
  }, []);

  useEffect(() => {
    fetch();
  }, [fetch]);

  return (
    <>
      <Breadcrumbs activeId={1} />

      <div className="bg-light">
        <RenderParks parksData={parksData} />
      </div>
    </>
  );
}
